import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuluc10 from "components/Phuluc10/Phuluc10.js";
export default function BCPhuluc10() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Phương tiện tham gia hoạt động kinh doanh vận tải",
            tabContent: <Phuluc10 />,
          },
        ]}
      />
    </div>
  );
}
